//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { createContext, type Dispatch, type SetStateAction } from 'react';
import { type ChatMessage } from '@/components/Chat/ChatTypes';

// -----------------------------------------------------------------------
// Chat context value — the chat transcript, hosted in its own context and
// provider (ChatProvider).  The panel's geometry and open state live in the
// panel registry instead, shared with every other panel.
// -----------------------------------------------------------------------

export interface ChatContextValue {
  chatMessages: ChatMessage[];
  setChatMessages: Dispatch<SetStateAction<ChatMessage[]>>;
  // The agent conversation this transcript belongs to.  Held here rather
  // than in the panel body because the Graphs page also reads it, to fetch
  // a draft the agent named by version.
  conversationId: string | null;
  setConversationId: Dispatch<SetStateAction<string | null>>;
}

const ChatContext = createContext<ChatContextValue | null>(null);

export { ChatContext };
